import Chart from "chart.js/auto";
import { deepMerge } from "../utils.js";
import { isDarkMode, onColorSchemeChange } from "../color-scheme.js";

Chart.defaults.interaction.mode = 'index';
Chart.defaults.interaction.intersect = false;

Chart.defaults.plugins.tooltip.borderWidth = 1;
Chart.defaults.plugins.tooltip.borderColor = 'rgba(120, 120, 120, 0.5)';
Chart.defaults.plugins.tooltip.usePointStyle = true;

export default class ColorThemeAwareDiagram extends HTMLElement {
  defaultChartOptions = {
    plugins: {
      tooltip: {
        backgroundColor: _ => this.computedStyle.getPropertyValue('background-color'),
        titleColor: _ => this.textColor,
        titleFont: {
          family: _ => this.fontFamily,
          size:   _ => Number.parseInt(this.computedStyle.getPropertyValue('font-size')) * 1.2
        },
        bodyColor: _ => this.textColor,
        bodyFont: {
          family: _ => this.fontFamily,
          size:   _ => Number.parseInt(this.computedStyle.getPropertyValue('font-size'))
        },
      }
    }
  }

  set chartOptions(opts) {
    this._chartOptions = deepMerge({}, opts, this.defaultChartOptions);
  }

  get chartOptions() {
    return this._chartOptions;
  }

  graphColors = [
    '51,102,204',
    '220,57,18',
    '255,153,0',
    '16,150,24',
    '153,0,153',
    '59,62,172',
    '0,153,198',
    '221,68,119',
    '102,170,0',
    '184,46,46',
    '49,99,149',
    '153,68,153',
    '34,170,153',
    '170,170,17',
    '102,51,204',
    '230,115,0',
    '139,7,7',
    '50,146,98',
    '85,116,166',
    '59,62,172',
    '20,20,20',
    '30,20,20',
    '40,20,20',
    '50,20,20',
    '60,20,20',
    '70,20,20',
    '70,20,20',
    '80,20,20',
    '90,30,20',
    '20,40,20',
    '20,50,20',
    '20,60,20',
    '20,70,20',
    '20,80,20',
    '20,90,20',
    '20,20,30',
    '20,20,40',
    '20,20,50',
    '20,20,60',
    '20,20,70',
    '20,20,80',
    '20,20,90'
  ]

  constructor() {
    super();

    this.datasetSelector = this.dataset.datasetSelector || 'tr.dataset'
    this.computedStyle = window.getComputedStyle(this);

    onColorSchemeChange(this.handleColorSchemeChange.bind(this));
    this.handleColorSchemeChange({matches: isDarkMode()});
  }

  connectedCallback() {
    window.setTimeout(e => this.connect(), 0);
  }

  handleColorSchemeChange(event) {
    this.borderColor = this.computedStyle.getPropertyValue('background-color');
    this.textColor   = this.computedStyle.getPropertyValue('color');
    this.fontFamily  = this.computedStyle.getPropertyValue('font-family');

    if (event.matches) {
      this.setDarkColorScheme();
    } else {
      this.setLightColorScheme();
    }

    if (this.chart) {
      this.chart.update();
    }
  }

  setDarkColorScheme() {
    // console.debug('setting dark theme; override this in your Subclass to add custom styles');
  }

  setLightColorScheme() {
    // console.debug('setting light theme; override this in your Subclass to add custom styles');
  }

  get canvas() {
    return this.querySelector('canvas');
  }

  buildChart(type, data, options) {
    this.chart = new Chart(this.canvas.getContext('2d'), {type: type, data: data, options: options});
  }

}

